module.exports = __webpack_public_path__ + "media/images/landing__seasonPrize__prize0-787e7f46226c86186442bdb25342f298.jpg";